/**
 * RatingStars Atom Component
 * Displays star rating with optional review count
 */

import { cn } from '@/lib/utils'
import { Star } from 'lucide-react'

interface RatingStarsProps {
	rating: number // 0-5
	reviewCount?: number
	size?: 'sm' | 'md' | 'lg'
	showCount?: boolean
	className?: string
}

const sizeClasses = {
	sm: 'w-3 h-3',
	md: 'w-4 h-4',
	lg: 'w-5 h-5',
}

export function RatingStars({
	rating,
	reviewCount,
	size = 'md',
	showCount = true,
	className,
}: RatingStarsProps) {
	const fullStars = Math.floor(rating)
	const hasHalfStar = rating % 1 >= 0.5

	return (
		<div className={cn('flex items-center gap-1', className)}>
			<div className='flex items-center'>
				{[...Array(5)].map((_, index) => {
					const isFilled = index < fullStars
					const isHalf = index === fullStars && hasHalfStar

					return (
						<Star
							key={index}
							className={cn(
								sizeClasses[size],
								isFilled || isHalf
									? 'fill-[#CDFF00] text-[#CDFF00]'
									: 'text-gray-300'
							)}
						/>
					)
				})}
			</div>

			{showCount && reviewCount !== undefined && (
				<span className='text-sm text-gray-600'>({reviewCount})</span>
			)}
		</div>
	)
}
